
import Information from './Information.vue'
import Calendar from './Calendar.vue'
import Purchase from './Purchase.vue'
import UserInformation from './UserInformation.vue'
import Done from './Done.vue'
import Error from './Error.vue'
import Registered from './Registered.vue'
import { REZERVATION_REQUEST } from '~/plugins/rezzervation'
import InnerLoading from '../Shared/Loading/InnerLoading.vue'
export default {
  props: {
    value: {
      default: false,
    },
    item: {
      default: () => {},
    },
    product: {
      default: () => {},
    },
  },
  computed: {
    getCompanyRezzervationInformation() {
      return this.$store.getters['seances/getCompanyRezzervationInformation']
    },
    getActiveUser() {
      return this.$store.getters['user/getActiveUser']
    },
  },
  components: {
    Information,
    Calendar,
    Purchase,
    UserInformation,
    Done,
    Error,
    Registered,
    InnerLoading,
  },
  methods: {
    LISTEN_MESSAGE() {
      const vm = this
      var eventMethod = window.addEventListener
        ? 'addEventListener'
        : 'attachEvent'
      var eventer = window[eventMethod]
      var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message'
      // Listen to message from child window
      eventer(
        messageEvent,
        function (e) {
          var key = e.message ? 'message' : 'data'
          var dataString = e[key]
          let data = dataString
          try {
            data = JSON.parse(dataString)
          } catch (error) {
            data = dataString
          }
          if (data === 'rezzervation is succeed') {
            vm.step = 3
          }
          //run function//
        },
        false
      )
    },
    async GET_USER_INFORMATION() {
      if (!this.getActiveUser.token) return (this.pageLoaded = true)
      this.pageLoaded = false
      const response = await REZERVATION_REQUEST(
        'Customers/ExternalLogin',
        'post',
        {
          Fullname: this.item.Fullname,
          Email: this.item.Email,
          CompanyId: this.getCompanyRezzervationInformation.Id,
        }
      )
      if (response.message === 'OK') {
        this.appointment = {
          ...this.item,
          Token: response.data.Token,
          Email: response.data.Email,
          Fullname: response.data.Fullname,
          Id: response.data.Id,
        }
      }
      this.pageLoaded = true
    },
  },
  mounted() {
    this.$router.push({ query: { ...this.$route.query, rez: 'modal' } })
    document.body.classList.add('overflow-hidden')
    this.GET_USER_INFORMATION()
    this.LISTEN_MESSAGE()
  },
  beforeDestroy() {
    document.body.classList.remove('overflow-hidden')
  },
  data() {
    return {
      newRezId: 0,
      pageLoaded: false,
      appointment: { Id: -1 },
      step: 1,
      date: {
        val: '',
        text: '',
      },
      time: '',
    }
  },
}
